const defaultValue = {
  isOpen: false,
  productId: null,
};

export default defaultValue;
